import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { useAuth } from '@/features/auth/AuthProvider'
import { AuthIllustration } from '@/features/auth/pages/auth/AuthIllustration'
import { useLanguage } from '@/hooks/useLanguage'
import { betaT } from '../locale'

export const BetaLayout = ({ children }: { children: ReactNode }) => {
  const { language } = useLanguage()
  const l = betaT[language]
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await logout()
    navigate('/auth', { replace: true })
  }

  // white by design: fixed-dark Beta hero, not app surface — see bg-[#0E0E12] below
  return (
    <main className="min-h-dvh flex flex-col lg:flex-row bg-[#0E0E12] relative">
      <div className="absolute top-8 left-1/2 -translate-x-1/2 sm:left-8 sm:translate-x-0 sm:top-10 lg:left-16 xl:left-24 flex items-center z-10">
        <img src="/logo-white.svg" alt="Open Academy" className="h-8 sm:h-8 w-auto" />
      </div>

      <div className="flex-1 flex flex-col justify-center px-4 sm:px-8 lg:px-16 xl:px-24 pt-16 pb-8 lg:py-0 relative">
        <button
          type="button"
          onClick={handleSignOut}
          className="absolute top-9 right-4 -translate-y-1/2 sm:top-10 sm:translate-y-0 sm:right-8 lg:right-8 xl:right-16 z-10 flex items-center gap-1.5 sm:gap-2 px-2 py-1.5 sm:px-3 sm:py-2 rounded-lg text-xs sm:text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors"
        >
          <LogOut className="w-4 h-4" />
          <span>{l.signOut}</span>
        </button>
        <div className="w-full max-w-[400px] mx-auto">{children}</div>
      </div>

      <AuthIllustration />
    </main>
  )
}
